namespace GeniuzPOS.InventoryReport {
    export class IcReport08DtColumns {
        static columnsKey = 'InventoryReport.IcReport08Dt';
    }
}
